import {createApp, defineAsyncComponent, getCurrentInstance} from 'vue'
import * as Vuex from 'vuex'

import DomToComponentMixin from '@tfx/common/mixins/dom-to-component'
import isCustomElement from '../../webpack-config/is-custom-element'
import {setupTestid} from '@/common/test-helper'
import WillValidate from '@tfx/common/directives/willvalidate'

const globals = {
  plugins: [],
  components: new Map(),
  directives: new Map()
}

let currentApp

export const VueComponent = (name, component) => {
  if (currentApp) {
    console.error(`^^^ VueComponent ${name} after app created.`)
  }

  globals.components.set(name, typeof component === 'function'
    ? defineAsyncComponent(component)
    : component
  )
}

export const VueDirective = (name, directive) => {
  if (currentApp) {
    console.error(`^^^ VueDirective ${name} after app created.`)
  }
  globals.directives.set(name, directive)
}

export const VueUse = (plugin) => {
  if (currentApp) {
    console.error('^^^ VueUse adter app created.')
  }

  globals.plugins.push(plugin)
}

export const createStore = (...args) => {
  return new Vuex.Store(...args)
}

function setupAppConfig(app) {
  app.config.debug = process.env.NODE_ENV !== 'production'
  app.config.devTools = process.env.NODE_ENV !== 'production'
  app.config.compilerOptions.isCustomElement = isCustomElement
}

export const createAppComponent = (options = {}, props = null) => {
  const app = createApp(options, props)
  setupAppConfig(app)

  setupTestid(app)
  app.mixin(DomToComponentMixin)
  app.use(WillValidate)

  globals.plugins.forEach((plugin) => app.use(plugin))
  globals.components.forEach((component, name) => app.component(name, component))
  globals.directives.forEach((directive, name) => app.directive(name, directive))

  currentApp = app

  return app
}

export const createTqAppComponent = (options = {}, props = null) => {
  const app = createApp(options, props)
  setupAppConfig(app)

  setupTestid(app)
  app.mixin(DomToComponentMixin)
  app.use(WillValidate)

  // tq has its own components with the same names
  const conconflictComponents = new Set([
    'confirmation-dialog',
    'modal-dialog'
  ])

  globals.components.forEach((component, name) => {
    if (!conconflictComponents.has(name)) {
      app.component(name, component)
    }
  })
  globals.directives.forEach((directive, name) => app.directive(name, directive))

  currentApp = app

  return app
}

// required for payment dialog / _card_dialog.js.erb
window.createAppComponent = createAppComponent

export const useStore = () => {
  const inst = getCurrentInstance()
  if (inst) {
    return inst.proxy.$store
  }
  return undefined
}

export const setupRouter = (router) => {
  const inst = getCurrentInstance()
  if (!inst.proxy.$router) {
    inst.appContext.app.use(router)
  } else {
    inst.proxy.$router = router
  }
}
